var React = require('react');

function SendBack (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M608 256H416a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V288a32 32 0 0 0-32-32zm-32 192H448V320h128zM224 0H32A32 32 0 0 0 0 32v192a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-32 192H64V64h128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384 416H208a48 48 0 0 1-48-48V256h64a32 32 0 0 0 32-32V96h176a48 48 0 0 1 48 48v112h-64a32 32 0 0 0-32 32z","className":"fa-primary","key":2})]);
}

SendBack.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = SendBack;

SendBack.default = SendBack;
